'use client';

import React from 'react';

import styles from './Content.module.css';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const Content = ({ children, className }: Props) => {
  return (
    <main className={`${styles.content} ${className || ''}`}>
      {children}
    </main>
  );
};

export default Content;
